import React, { useState } from 'react';
import Calendar from './components/Calendar/Calendar';
import MonthNavigator from './components/MonthNavigator/MonthNavigator';
import HeroImage from './components/HeroImage/HeroImage';
import Notes from './components/Notes/Notes';
import './App.css';

function App() {
  const today = new Date();
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [selectedDate, setSelectedDate] = useState(null);

  const handlePrevMonth = () => {
    if (currentMonth === 0) {
      setCurrentYear(currentYear - 1);
      setCurrentMonth(11);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  };

  const handleNextMonth = () => {
    if (currentMonth === 11) {
      setCurrentYear(currentYear + 1);
      setCurrentMonth(0);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  };

  const handleDateSelect = (date) => {
    setSelectedDate(date);
  };

  return (
    <div className="App">
      <div className="calendar-page">
        <div className="left-panel">
          <HeroImage month={currentMonth} />
          <MonthNavigator
            year={currentYear}
            month={currentMonth}
            onPrev={handlePrevMonth}
            onNext={handleNextMonth}
          />
          <Calendar
            year={currentYear}
            month={currentMonth}
            onDateSelect={handleDateSelect}
          />
        </div>
        <div className="right-panel">
          <Notes selectedDate={selectedDate} />
        </div>
      </div>
    </div>
  );
}

export default App;
